<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-container fluid>
            <v-card>
                <v-toolbar dark color="blue">
                    <v-toolbar-title class="my-0 py-0">Tablero de Indicadores / Objetivos</v-toolbar-title>
                    <v-spacer></v-spacer>
                    Fecha de Captura: {{ fecha }}
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn icon @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-toolbar>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-row>
                        <!-- Grupos por Objclave/Sector -->
                        <v-col v-for="(objetivo, index) in (objetivos || [])" :key="index" cols="2">
                            <!-- CABECERA -->
                            <v-card class="pa-2 text-center white--text font-weight-bold" :color="objetivo.color">
                                <div class="text-h6">Objetivo {{ objetivo.objclave }}</div>
                                <div class="text-subtitle-2">{{ objetivo.sector }}</div>
                            </v-card>

                            <!-- BLOQUES ORDENADOS -->
                            <div v-for="(bloque, bIndex) in (objetivo.bloques || [])" :key="bIndex">
                                <v-sheet color="grey lighten-2" class="pa-1 text-center font-weight-medium my-1">
                                    {{ bloque.titulo }}
                                </v-sheet>

                                <v-row dense>
                                    <v-col v-for="(it, iIndex) in (bloque.items || [])" :key="iIndex"
                                        :cols="bloque.columnas || 12">
                                        <!-- INDICADOR -->
                                        <v-card v-if="it.tipo === 'IND'" class="pa-2 card-indicador"
                                            :color="colorCumplimiento(it.ind)"
                                            :dark="colorCumplimiento(it.ind) !== 'yellow'"
                                            :class="{ 'black--text': colorCumplimiento(it.ind) === 'yellow' }">
                                            <div class="font-weight-bold text-subtitle-1"
                                                @click="verIndicadores(it.ind.indicador)">
                                                Indicador: {{ it.ind.indicador }}
                                            </div>
                                            <div class="text-caption text-wrap">
                                                {{ it.ind.descrcorta }}
                                            </div>
                                            <div class="text-caption text-truncate mt-1">Rev: {{ it.ind.fecha }}</div>
                                            <v-icon small>{{ iconoTendencia(it.ind.tendencia) }}</v-icon>
                                            <!-- Objetivos vinculados -->
                                            <div v-if="it.ind.objetivosVinculados && it.ind.objetivosVinculados.length"
                                                class="w-100 mt-1">
                                                <v-divider class="my-1"></v-divider>
                                                <div v-for="(obv, k) in it.ind.objetivosVinculados" :key="k"
                                                    class="d-flex align-center justify-space-between objetivo-chip">
                                                    <div class="text-caption text-left mr-2 text-truncate"
                                                        @click="verObjetivos(obv.codgral)">
                                                        Objetivo: {{ obv.codgral }} - Rev: {{ obv.fecha }}
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>

                                        <!-- OBJETIVO SUELTO (no vinculado) -->
                                        <v-card v-else-if="it.tipo === 'OBJ'" class="pa-2 card-indicador"
                                            :color="colorCumplimientoOb(it.obj)"
                                            :dark="colorCumplimientoOb(it.obj) !== 'yellow'"
                                            :class="{ 'black--text': colorCumplimientoOb(it.obj) === 'yellow' }">
                                            <div class="font-weight-bold text-subtitle-1"
                                                @click="verObjetivos(it.obj.codgral)">
                                                Objetivo: {{ it.obj.codgral }}
                                            </div>
                                            <div class="text-caption text-wrap">
                                                <!-- {{ it.obj.objetivo }} -->
                                                {{ it.obj.objetivo.length > 200 ? it.obj.objetivo.substring(0, 200) +
                                                    '...' :
                                                    it.obj.objetivo }}
                                            </div>
                                            <div class="text-caption text-truncate">Rev: {{ it.obj.fecha }}</div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <!-- <Cumplimiento :visible="showCumplimiento" :codgral="this.filtrocodgral" :periodo="this.anio"
            @close="showCumplimiento = false">
        </Cumplimiento>-->
            <Indicadores :visible="showIndicadores" :indicador="this.indicadorId" @close="showIndicadores = false">
            </Indicadores>
            <Objetivos :visible="showObjetivos" :codgral="this.objetivoId" :fecha="this.fecha"
                @close="showObjetivos = false">
            </Objetivos>
        </v-container>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../src/axios-auth";
import Objetivos from "../Objetivos/Informe.vue";
import Indicadores from "../Indicadores/Informe.vue";
export default {
    components: { Indicadores, Objetivos },
    name: "TableroJerarquico",
    data() {
        return {
            showObjetivos: false,
            showIndicadores: false,
            indicadorId: "",
            objetivoId: "",
            filtrocodgral: "",
            filtrosector: "",
            anio: moment().format("YYYY"),
            periodo: "",
            periodos: [{ text: "1° Semestre", value: "1" },
            { text: "2° Semestre", value: "2" },
            ],
            objetivos: null,
            deshabilitar: false,
            //fecha: "",
            mostrar: false,
        };
    },
    props: ["visible", "fecha"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarTablero();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$emit("close");
                }
                //  this.visible = value;
            },
        },
    },
    methods: {
        vaciarListado() {
            this.objetivos = [];
            this.deshabilitar = false;
        },
        cargarTablero() {
            const fecha = this.fecha;
            axios
                .get("/Indicadores/GetIndicadoresParciales", { params: { fecha: fecha } })
                .then((response) => {
                    this.objetivos = (response.data || []).map((g) => {
                        (g.bloques || []).forEach((b) => {
                            // compat-backend: asegurar items
                            if (!b.items || !Array.isArray(b.items)) b.items = [];
                            if (!b.items.length && b.indicadores && b.indicadores.length) {
                                b.items = b.indicadores.map((ind) => ({ tipo: "IND", ind }));
                            }
                            // asegurar objetivosVinculados
                            (b.indicadores || []).forEach((it) => {
                                if (!it.objetivosVinculados) it.objetivosVinculados = [];
                            });
                        });
                        return g;
                    });
                })
                .catch(() => {
                    this.objetivos = [];
                });
        },
        colorCumplimiento(item) {
            //console.log("condicion: ", item.indicador, " - ", item.condicion, " - ", item.valor, " - ", item.referencia)
            if (item.valor == null || item.valor == "") { return "grey"; }
            if (item.condicion == "MAYOR") {
                return +item.valor >= +item.referencia ? "#00A000" : "#C62828";
            } else if (item.condicion == "MENOR") {
                return +item.valor <= +item.referencia ? "#00A000" : "#C62828";
            }
            return "grey";
        },
        colorCumplimientoOb(item) {
            //  console.log("valor ", item.valoractual)
            const v = +item.valoractual;
            if (v == 100) return "#00A000";
            if (v == 0) return "#C62828";
            if (v > 0 && v < 100) return "yellow";
            return "grey"; // ajustar si querés color intermedio
        },
        iconoTendencia(t) {
            switch (t) {
                case "P":
                    return "mdi-arrow-up-bold";
                case "N":
                    return "mdi-arrow-down-bold";
                case "C":
                    return "mdi-arrow-left-right-bold";
                default:
                    return "mdi-minus";
            }
        },

        // editarCumplimiento(item) {
        //     this.filtrocodgral = item;
        //     this.showCumplimiento = true;
        // },
        verIndicadores(item) {
            if (item == "G1" || item == "G1A" || item == "G1B" || item == "G1C" || item == "G1D" || item == "G1E") {
                window.open('https://lookerstudio.google.com/reporting/5d9ee2a8-5cf2-4ce9-91e1-5e8008775c87/page/QOdoD', '_blank');
            }
            else if (item == "G1ASPV" || item == "G1BSPV" || item == "G1CSPV" || item == "G1DSPV" || item == "G1ESPV" || item == "G1GSPV") {
                window.open('https://lookerstudio.google.com/reporting/42684c49-afac-4548-b163-124b3b522e5b/page/QOdoD', '_blank');
            }
            else {
                this.indicadorId = item;
                this.showIndicadores = true;
            }
        },
        verObjetivos(item) {
            this.objetivoId = item;
            this.showObjetivos = true;
            console.log("item", item)
        },


    },
};
</script>

<style scoped>
.text-wrap {
    white-space: normal !important;
    word-break: break-word;
    line-height: 1;
    font-size: smaller;
}

.card-indicador {
    height: 150px;
    width: 100%;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    text-align: center;
    border-radius: 12px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-indicador:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.objetivo-chip {
    width: 100%;
    gap: 4px;
}
</style>
